<div *ngIf="displayAcceptCookies" class="acceptCookies">
    <div class="acceptCookies__text">DFDS uses cookies to give you the best experience on our website.
        <a class="acceptCookies__readmore" (click)="readMoreAboutCookies()">Read more</a>
    </div>
    <div class="acceptCookies__buttons">
        <a class="acceptCookies__buttons__reject" (click)="rejectCookies()">Reject</a>
        <button class="acceptCookies__buttons__accept" (click)="acceptCookies()">Accept</button>
    </div>
</div>

<ng-container *ngIf="displayReadMoreAboutCookies">
    <sbw-popup2 #popup [closable]="true" (closing)="displayReadMoreAboutCookies=false">
        <sbw-contentful-generic-page UrlSlugEntryTitle="legal/cookies"
            [InfoBlockBehaviour]="InfoBlockBehaviourEnum.Accordion" (onData)="popup.setHeading(getHeading($event))">
        </sbw-contentful-generic-page>
        <div class="row">
            <div class="columns large-8 large-push-2">
                <sbw-button type="preferred" (click)="displayAcceptCookies=false; acceptCookies()"
                    text="Accept cookies"></sbw-button>
            </div>
        </div>
    </sbw-popup2>
</ng-container>

<ng-container *ngIf="displayRejectCookies">
    <sbw-popup2 #popup [closable]="true" (closing)="displayRejectCookies=false">
        <sbw-contentful-generic-page UrlSlugEntryTitle="legal/cookies-decline"
            [InfoBlockBehaviour]="InfoBlockBehaviourEnum.Accordion" (onData)="popup.setHeading(getHeading($event))">
        </sbw-contentful-generic-page>
        <div class="row">
            <div class="columns large-8 large-push-2">
                <sbw-button type="preferred" (click)="displayRejectCookies=false; acceptCookies()"
                    text="Accept cookies"></sbw-button>
            </div>
        </div>
    </sbw-popup2>
</ng-container>
